$('.feedback_link').off('click').click(function (a) {
    let url = $(this).data('page');
    let errorMessage = $(this).data('error');
    let sentMessage = $(this).data('sent');
    let sentTitle = $(this).data('sent-title');

    swal({
        title: $(this).data('hi'),
        text:  $(this).data('message'),
        type: "question",
        input: "textarea",
        showCancelButton: true,
        closeOnConfirm: false,
        showLoaderOnConfirm: true,
        animation: "slide-from-top",
        confirmButtonText: $(this).data('confirm'),
        cancelButtonText: $(this).data('cancel'),
        inputPlaceholder: $(this).data('placeholder'),
        preConfirm: function (inputValue) {
            return new Promise(function (resolve, reject) {
                if (inputValue === "" || inputValue.length < 10) {
                    reject(errorMessage);
                    return false
                }

                $.ajax({
                    type: "POST",
                    url: laroute.route('public::feedback::ajax::send'),
                    data: {
                        message: inputValue,
                        url: url
                    }
                }).done(function (msg) {
                    if (msg.error) {
                        reject(msg.message);
                    }else{
                        resolve();
                    }
                });
            })
        },
    }).then(
        function (inputValue) {
            swal(sentTitle, sentMessage)

        },
        // handling the promise rejection
        function (dismiss) {}
    );


    //     if (msg.error) {
    //         $.sticky('<b>' + msg.list + '</b><br />' + msg.message, {
    //             autoclose: 3000,
    //             position: 'top-right',
    //             type: 'st-error'
    //         });
    //     } else {
    //         bootbox.confirm("<b>" + msg.list + "</b><br />" + msg.message, function (confirmed) {
    //             if (confirmed) {
    //                 $.ajax({
    //                     type: "POST",
    //                     url: laroute.route('public::lists::ajax::buy_list', {guid: guid})
    //                 }).done(function (msg) {
    //                     if (!msg.error) {
    //                         $('.add-to-cart-track-btn').remove();
    //                         $('.buy-now-track-btn').remove();
    //                         $('.buy-now-list-btn').remove();
    //
    //                         if (msg.url)
    //                             location.href = msg.url;
    //                     }
    //
    //                     bootbox.alert('<b>' + msg.list + '</b><br />' + msg.message, function () {
    //                     });
    //                 });
    //             }
    //         });
    //     }
});
